/**
 * Type used for general app configuration, values taken from process.env
 */

export type PackageConfig = {
  environment: {
    isProd: boolean;
    isDev: boolean;
  };
};

const config: PackageConfig = {
  environment: {
    isDev: NODE_ENV === 'development',
    isProd: NODE_ENV === 'production',
  },
};

export default config;
